import React from 'react'
import { useTranslation } from 'react-i18next'

function Header() {
  const { t } = useTranslation()

  return (
    <header className="tc-inner-header-style1 pb-50">
      <div className="container">
        <div className="info col-lg-7">
          <h1 className="js-title marcellus">{t('gallery.title')}</h1>

          <div className="text fsz-18 color-666 mb-30 marcellus">
            {t('gallery.subtitle')}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
